import styled from 'styled-components';

import { theme } from '../layout/theme';

export const Link = styled.a`
  &.underline {
    text-decoration: underline;
  }

  &.subtle {
    color: #000;
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${theme.colors.text.link};
  transition: 50ms;

  &:hover {
    color: ${theme.colors.text.linkHover};
  }

  &.ghost {
    color: ${theme.colors.text.ghost};
  }

  &.hover-ghost {
    position: static;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &.inline-flex {
    display: inline-flex;
    align-items: center;
  }

  &.medium {
    font-weight: ${theme.font.weight.medium};
  }

  &.inactive {
    color: ${theme.colors.text.main};
  }

  &[disabled] {
    color: ${theme.colors.button.ghost.disabledText};
    cursor: not-allowed;
  }
`;
